'use client'

import { createToast } from '@trustoo/components/ui/toaster/funcs/createToast'
import { toastReducer } from '@trustoo/components/ui/toaster/funcs/toastReducer'
import type {
    ToastActions,
    ToastOptions,
    ToastState,
} from '@trustoo/components/ui/toaster/types/toastTypes'
import { useMemo, useReducer } from 'react'

export interface ToastStore {
    toasts: ToastState
    /** Referentially stable, so a consumer that only fires toasts never re-renders on a change. */
    actions: ToastActions
}

/**
 * A self-contained toast store: the state plus the actions over it, with no provider and no global
 * of its own. `ToastProvider` uses it for the app channel.
 */
export const useToastStore = (): ToastStore => {
    const [toasts, dispatch] = useReducer(toastReducer, {})

    const actions = useMemo<ToastActions>(
        () => ({
            addToast: (options: ToastOptions = {}) =>
                dispatch({ type: 'add', toast: createToast(options) }),
            deleteToast: (id: string) => dispatch({ type: 'delete', id }),
            deleteAllToasts: () => dispatch({ type: 'deleteAll' }),
        }),
        [],
    )

    return { toasts, actions }
}
